export default __webpack_public_path__ + "static/media/ENTREVISTA-OTMARO.c9a1c692.png";